import React, { useEffect, useState } from 'react';
import 'moment/locale/pt';
import { Box, Button, FormControl, InputAdornment, InputLabel, OutlinedInput, TextField, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import InputMask from "react-input-mask";
import { removeCpfMask } from '../../../../../utils/functions';
import { enqueueSnackbar } from 'notistack';
import { PostFetch } from '../../../../../services/apiBase';

export default function NewPolModal({ open, onClose, getList }) {
  const [cpf, setCpf] = useState('');

  const [qtdNew, setQtdNew] = useState(1)
  const [newCad, setNewCad] = useState({})
  const [load, setLoad] = useState(false);

  const toggleAddCard = () => {
    let qtd = qtdNew + 1
    setQtdNew(qtd);
  }

  const toggleRemoveCard = () => {
    const qtd = qtdNew - 1
    if (newCad[`amount_start[${qtd}]`]) delete newCad[`amount_start[${qtd}]`]
    if (newCad[`amount_end[${qtd}]`]) delete newCad[`amount_end[${qtd}]`]
    if (newCad[`rate[${qtd}]`]) delete newCad[`rate[${qtd}]`]
    setQtdNew(qtd);
  }

  const handleOnChange = (e) => {
    const key = e.target.id
    var value
    value = e.target.value
    setNewCad({...newCad, [key]: value })
  }

  const handleOnCloseModal = () => {
    setNewCad({})
    setQtdNew(1)
    onClose()
  }

  const handleSubmit = async () => {
    try {
      setLoad(true)
      for(let i=0; i<qtdNew; i++) {

        const response = await PostFetch(`/financial/createTradeAgreement`, {
          "type": "CPF",
          "document_number": removeCpfMask(cpf),
          "amount_start": newCad[`amount_start[${i}]`],
          "amount_end": newCad[`amount_end[${i}]`],
          "rate": newCad[`rate[${i}]`],
          "is_actived": true
        });
      }
      enqueueSnackbar('Nova política cadastrada com sucesso!', { variant: 'success' });
      
      handleOnCloseModal()
      getList()
      setLoad(false)
    } catch (error) {
      enqueueSnackbar('Erro ao cadastrar nova política!', { variant: 'error' });
      
      handleOnCloseModal()
      setLoad(false)
    }
  }

  return (
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      boxShadow: 24,
      borderRadius: 2,
      backgroundColor: grey[300]
    }}>
      <Box sx={{
        padding: '16px',
        borderRadius: '8px 8px 0 0',
        backgroundColor: '#fff'
      }}>
        <Typography variant="h6" component="h2">
          Cadastrar nova política
        </Typography>
      </Box>

      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#fff',
        padding: 1,
        gap: 2,
      }}>
        <InputMask
          mask="999.999.999-99"
          maskChar=" "
          value={cpf}
          onChange={(event) => setCpf(event.target.value)}
          >
          {() =>
            <TextField
              label="CPF"
            />}
        </InputMask>
      </Box>

      <Box sx={{
        marginTop: '16px',
        marginBottom: '16px',
        marginRight: '32px',
        width: 400,
        minWidth: 400,
        maxHeight: '80%',
        height: '90%',
        width: '100%',
        backgroundColor: '#fff',
        borderRadius: 1,
        display: 'flex',
        flexDirection: 'column',
      }}>

        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: 1,
          gap: 2,
        }}>
          {qtdNew && Array(qtdNew).fill(0).map((_, index) => (
            <Box sx={{
              display: 'flex',
              flexDirection: 'column',
              border: '1px solid',
              borderRadius: 1,
              padding: 1,
              gap: 2,
            }}>
              <FormControl fullWidth>
                <TextField
                  id={`amount_start[${index}]`}
                  label="Valor inicial"
                  type="number"
                  onChange={(event) => {
                    handleOnChange(event);
                  }}
                />
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  id={`amount_end[${index}]`}
                  label="Valor final"
                  type="number"
                  onChange={(event) => {
                    handleOnChange(event);
                  }}
                />
              </FormControl>

              <FormControl fullWidth>
                <InputLabel id={`rate[${index}]`}>Taxa</InputLabel>
                <OutlinedInput
                  id={`rate[${index}]`}
                  endAdornment={<InputAdornment position="end">%</InputAdornment>}
                  label="Taxa"
                  onChange={(event) => {
                    handleOnChange(event);
                  }}
                />
              </FormControl>
            </Box>
          ))}

          <Box sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'flex-end',
            gap: 1,
            borderRadius: '0 0 8px 8px',
            backgroundColor: '#fff'
          }}>
            {qtdNew > 1 && 
              <Button variant="contained" color='error' onClick={() => toggleRemoveCard()}>
                <Typography color={'#fff'}>
                  -
                </Typography>
              </Button>
            }
            <Button variant="contained" color={'success'} onClick={() => toggleAddCard()}>
              <Typography color={'#fff'}>
                +
              </Typography>
            </Button>
          </Box>
        </Box>
      </Box>

      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
        gap: 1,
        padding: 2,
        borderRadius: '0 0 8px 8px',
        backgroundColor: '#fff'
      }}>
        <Button variant="contained" color={'success'}>
          <Typography color={'#fff'} onClick={() => handleSubmit()}>
            Cadastrar
          </Typography>
        </Button>
        <Button variant="contained" color='error' onClick={onClose}>
          <Typography color={'#fff'}>
            Fechar
          </Typography>
        </Button>
      </Box>
    </Box>
  )
}
